import { Component, Input, OnInit } from '@angular/core';

export interface TaxRedutionLabel {
  currentYear: number;
  duration: number;
  reduction: number;
  amount: number;
  position?: number;
}

@Component({
  selector: 'ea-tax-reduction',
  templateUrl: './ea-tax-reduction.component.html',
  styleUrls: ['./ea-tax-reduction.component.scss'],
  standalone: false,
})
export class EaTaxReductionComponent implements OnInit {
  @Input() data: TaxRedutionLabel;
  @Input() title: string;
  @Input() subTitle: string;
  @Input() type: string = '';

  taxValue: number;
  taxValuePos: number;
  prefixedTypeBefore: string;
  prefixedTypeAfter: string;

  constructor() {}

  ngOnInit() {
    this.editTitleColumns(this.type);
  }

  editTitleColumns(type) {
    switch (type) {
      case 'PER':
      case 'Pinel':
      case 'Fip':
      case 'Fcpi':
      case 'Girardin':
      case 'Sofica': {
        this.prefixedTypeBefore = 'Sans ' + type;
        this.prefixedTypeAfter = 'Avec ' + type;
        break;
      }
      case 'PME': {
        this.prefixedTypeBefore = 'Avant private equity';
        this.prefixedTypeAfter = 'Après private equity';
        break;
      }
      default: {
        this.prefixedTypeBefore = 'Avant réduction';
        this.prefixedTypeAfter = 'Après réduction';
        break;
      }
    }
  }

  get calculRate() {
    if (this.data.reduction <= 0 || this.data.amount <= 0) {
      return 206;
    } else {
      if (this.data.reduction / this.data.amount >= 0.9) {
        return 19;
      } else if (this.data.reduction / this.data.amount < 0.1) {
        return 187;
      } else {
        return (1 - this.data.reduction / this.data.amount) * 206;
      }
    }
  }

  get reduction() {
    if (this.data.reduction < 0) {
      return 0;
    } else if (this.data.reduction >= this.data.amount) {
      return this.data.amount;
    } else {
      return this.data.reduction;
    }
  }

  get amount() {
    if (this.data.amount < 0) {
      return 0;
    } else {
      return this.data.amount;
    }
  }

  get calcRemaining() {
    if (this.data.amount - this.data.reduction < 0) {
      return 0;
    } else {
      return this.data.amount - this.data.reduction;
    }
  }
}
